import { Component, Input, OnInit } from '@angular/core'
import { Observable } from 'rxjs'
import { LocaleCode } from 'src/app/interfaces/locale'
import { LocaleService } from 'src/app/services/locale/locale-service'
import { ModalService } from 'src/app/services/modal/modal.service'

interface AlertDialogButton {
  text: string
  role: 'cancel' | 'confirm'
  action?: () => Observable<any>
}

export interface AlertDialogData {
  image?: string
  title: string
  description: string
  buttons: AlertDialogButton[]
}

@Component({
  selector: 'app-login-alert-dialog',
  templateUrl: './login-alert-dialog.component.html',
  styleUrls: ['./login-alert-dialog.component.scss'],
})
export class LoginAlertDialogComponent implements OnInit {
  @Input() title = ''
  @Input() description = ''
  @Input() onViewed?: () => void
  @Input() onClickLoginButton?: () => void
  locale$ = this.localeService.locale$
  eLocaleCode = LocaleCode

  constructor(private modalService: ModalService, private localeService: LocaleService) {}
  ngOnInit() {
    if (this.onViewed) {
      this.onViewed()
    }
  }

  onClickButton(): void {
    if (this.onClickLoginButton) {
      this.onClickLoginButton()
    }
    this.modalService.dismiss(true)
  }
}
